var app = angular.module('leonardo');

var WorkOrderPlatformService = function(BaseRestService) {
  return new BaseRestService('pms-platforms');
};

app.factory('WorkOrderPlatformService', ['BaseRestService', WorkOrderPlatformService]);
